import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { first, take, tap } from 'rxjs/operators';

import { INotification } from '../../../../domain/notification/notification';
import { MeetingRequestDialogController } from './meeting-request-dialog.controller';
import { MeetingRequestDialogData } from './meeting-request-dialog.data';
import { MeetingRequestDialogStore } from './meeting-request-dialog.store';

@Component({
	selector: 'spr-meeting-dialog',
	templateUrl: './meeting-request-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [MeetingRequestDialogStore, MeetingRequestDialogController],
})
export class MeetingRequestDialogComponent {
	public locale$: Observable<string>;
	public notification$: Observable<INotification>;

	constructor(
		private _router: Router,
		private _config: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef,
		private _controller: MeetingRequestDialogController
	) {
		const data: MeetingRequestDialogData = _config.data;

		_controller.setNotificationId(data.notificationId);
		this.notification$ = _controller.notification$;
		this.locale$ = _controller.locale$;
	}

	public onRejectClick() {
		this._controller
			.rejectMeeting()
			.pipe(take(1))
			.subscribe((_) => this._dialogRef.close());
	}

	public onChangeClick() {
		this.notification$
			.pipe(
				tap((notification) =>
					this._router.navigate([
						'/booth/availabilities',
						notification.meeting.coachId,
						'notification',
						notification.id,
					])
				),
				tap((_) => this._dialogRef.close()),
				first()
			)
			.subscribe();
	}

	public onAcceptClick() {
		this._controller
			.acceptMeeting()
			.pipe(take(1))
			.subscribe((_) => this._dialogRef.close());
	}
}
